import { Color, Radius, Spacing } from 'zens-storybook'
import React, { Suspense, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useStore, ScheduleData, Draft, StorageKey, ApiError, useScheduleMutation } from 'zens-store'
import { useRouter, useNumberParams } from 'zens-router'
import { useBreadcrumb } from '@dms/hook'
import { LayoutHeader, ScheduleForm } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
    padding: Spacing.L,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
  },
})

const ScheduleAdd = () => {
  const [errors, setErrors] = useState<Record<string, string>>()
  const router = useRouter()
  const store = useStore()
  const { message, storage } = store
  const [{ companyId }] = useNumberParams()
  const { t } = useTranslation()
  const mutation = useScheduleMutation({ companyId })

  const breadcrumb = useBreadcrumb([
    {
      title: t('Workspaces'),
      href: `/companies/${companyId}/workspaces`,
    },
    {
      title: t('Schedules'),
      href: `/companies/${companyId}/workspaces/schedules`,
    },
    {
      title: t('Add schedule'),
    },
  ])

  const add = async (draft: Draft<ScheduleData>) => {
    try {
      setErrors({})
      await mutation.create(draft)
      message.add({
        message: t('Schedule was created successfully'),
        status: 'success',
      })
      draft.data.floor_id && storage.set(`${companyId}:${StorageKey.Floor}`, `${draft.data.floor_id}`)
    } catch (error) {
      const { message: errorMessage, fields } = error as ApiError
      console.debug(`SCHEDULE: Schedule failed: ${errorMessage}`)
      if (fields) {
        setErrors(fields)
      } else {
        message.add({
          message: `${t('Schedule could not be created')}. ${errorMessage}`,
          status: 'error',
        })
      }
      return
    }

    router.push(`/companies/${companyId}/workspaces/schedules`)
  }

  return (
    <View style={styles.container}>
      <LayoutHeader breadcrumb={breadcrumb} title={t('Add schedule')} />
      <View style={styles.content}>
        <Suspense fallback={<ScheduleForm.Skeleton />}>
          <ScheduleForm companyId={companyId} onSave={add} errors={errors} />
        </Suspense>
      </View>
    </View>
  )
}

export default ScheduleAdd
